import { values } from './enums'

const _enum = {
  NotStarted: 0,
  Started: 1,
  Recalculated: 2,
  Validated: 3,
  XmlGenerated: 4,
  Signed: 5,
  TicketCreated: 6,
  Success: 7
}

export const submitReportProgress = {
  enumName: 'SubmitReportProgress',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/submitReportProgress.js